var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLqfirspeak1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 105,
    height: 105,
    viewBox: "0 0 105 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50",
    transform: "translate(5407 1953.155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union_9",
    "data-name": "Union 9",
    transform: "translate(-15041 -6575.155)",
    fill: "rgba(255,255,255,0.07)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9686.5,4622a52.5,52.5,0,1,1-52.5,52.5A52.5,52.5,0,0,1,9686.5,4622Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 9686.5 4626 C 9679.951171875 4626 9673.599609375 4627.28173828125 9667.623046875 4629.8095703125 C 9661.84765625 4632.25244140625 9656.6611328125 4635.75 9652.205078125 4640.205078125 C 9647.75 4644.66064453125 9644.251953125 4649.84765625 9641.8095703125 4655.62255859375 C 9639.2822265625 4661.599609375 9638 4667.95068359375 9638 4674.5 C 9638 4681.04931640625 9639.2822265625 4687.400390625 9641.8095703125 4693.37744140625 C 9644.251953125 4699.15234375 9647.75 4704.33935546875 9652.205078125 4708.794921875 C 9656.6611328125 4713.25 9661.84765625 4716.74755859375 9667.623046875 4719.1904296875 C 9673.599609375 4721.71826171875 9679.951171875 4723 9686.5 4723 C 9693.048828125 4723 9699.400390625 4721.71826171875 9705.376953125 4719.1904296875 C 9711.15234375 4716.74755859375 9716.3388671875 4713.25 9720.794921875 4708.794921875 C 9725.25 4704.33935546875 9728.748046875 4699.15234375 9731.1904296875 4693.37744140625 C 9733.7177734375 4687.400390625 9735 4681.04931640625 9735 4674.5 C 9735 4667.95068359375 9733.7177734375 4661.599609375 9731.1904296875 4655.62255859375 C 9728.748046875 4649.84765625 9725.25 4644.66064453125 9720.794921875 4640.205078125 C 9716.3388671875 4635.75 9711.15234375 4632.25244140625 9705.376953125 4629.8095703125 C 9699.400390625 4627.28173828125 9693.048828125 4626 9686.5 4626 M 9686.5 4622 C 9715.4951171875 4622 9739 4645.5048828125 9739 4674.5 C 9739 4703.4951171875 9715.4951171875 4727 9686.5 4727 C 9657.5048828125 4727 9634 4703.4951171875 9634 4674.5 C 9634 4645.5048828125 9657.5048828125 4622 9686.5 4622 Z",
    stroke: "none",
    fill: "rgba(255,255,255,0.06)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    transform: "translate(-5382.75 -1930.936)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M16.62,11.012c-.5.451-1.022,1.729-.355,4.4l0,.019c.822,3.416,3.3,7.909,7.138,12.224,3.871,4.319,8.04,7.282,11.316,8.459l.02.007.02.008c2.327.888,3.623.679,4.216.32l.2-.175a2.432,2.432,0,0,0,.654-1.749,10.78,10.78,0,0,0-.671-3.961,33.014,33.014,0,0,0-6.773-10.92,33.428,33.428,0,0,0-10.1-7.953,10.8,10.8,0,0,0-3.855-1.119,2.455,2.455,0,0,0-1.814.445Zm7.517-3.285a37.725,37.725,0,0,1,11.5,9A37.31,37.31,0,0,1,43.3,29.174a15.038,15.038,0,0,1,.887,5.63,7.126,7.126,0,0,1-1.379,3.949v.155l-.725.651c-2.373,2.131-5.828,1.809-8.861.656-4.177-1.507-8.913-5.007-13.075-9.651l-.005-.006c-4.14-4.653-7.078-9.769-8.122-14.1-.786-3.15-.672-6.587,1.682-8.7l.009-.008A6.748,6.748,0,0,1,18.655,6.2a15.065,15.065,0,0,1,5.482,1.524Z",
    transform: "translate(5.861 1.826)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M20.984,7.757a2.185,2.185,0,0,1,1.105,2.886L8.426,41.261l0,0a3.286,3.286,0,0,0,4,4.449h0L44.4,35.607a2.185,2.185,0,0,1,1.317,4.167L13.731,49.883l-.008,0A7.656,7.656,0,0,1,4.436,39.478h0L18.1,8.861a2.185,2.185,0,0,1,2.886-1.1Z",
    transform: "translate(0 2.855)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M26.06,26.334A2.185,2.185,0,0,1,28.8,27.765l1.543,4.92h0a7.35,7.35,0,0,1-4.777,9.179l-4.924,1.544h0a7.35,7.35,0,0,1-9.179-4.777L9.917,33.7a2.185,2.185,0,1,1,4.17-1.308l1.543,4.92h0a2.98,2.98,0,0,0,3.7,1.923L24.251,37.7h0A2.98,2.98,0,0,0,26.174,34l-1.545-4.926A2.185,2.185,0,0,1,26.06,26.334Z",
    transform: "translate(4.538 16.817)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M37.135,5.931a2.185,2.185,0,0,1,.017,3.09l-2.564,2.593a2.185,2.185,0,0,1-3.107-3.073l2.564-2.593a2.185,2.185,0,0,1,3.09-.017Z",
    transform: "translate(20.27 1.16)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M28.352,3.947a2.185,2.185,0,0,1,1.083,2.894L28.24,9.463a2.185,2.185,0,1,1-3.977-1.812l1.194-2.622a2.185,2.185,0,0,1,2.894-1.083Z",
    transform: "translate(15.197 0)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M38.908,13.9a2.185,2.185,0,0,1-.894,2.958l-2.447,1.311A2.185,2.185,0,0,1,33.5,14.32l2.447-1.311A2.185,2.185,0,0,1,38.908,13.9Z",
    transform: "translate(21.392 6.732)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLqfirspeak1);
export default __webpack_public_path__ + "static/media/lqfirspeak-1.1a6a7f05f21c33e56de9e523f2f18c01.svg";
export { ForwardRef as ReactComponent };